import React from "react";
import { WhatsappIcon } from "@/svgs";
import "./PremiumAccessModal.css";

interface PremiumAccessModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const PremiumAccessModal: React.FC<PremiumAccessModalProps> = ({
  isOpen,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          &times;
        </button>

        <div className="modal-icon">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <h2 className="modal-title">Acesso VIP Gratuito</h2>

        <div className="modal-body">
          <p>
            Sabia que <strong>Mulheres Verificadas</strong> possuem acesso
            totalmente
            <strong> GRATUITO</strong> à nossa plataforma?
          </p>
          <p className="modal-subtext">
            Para garantir seu selo e liberar seu perfil, clique no botão abaixo
            e nos envie uma mensagem solicitando sua aprovação.
          </p>

          <a
            href={process.env.REACT_APP_WHATSAPP}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-whatsapp"
          >
            <WhatsappIcon />
            Solicitar aprovação agora
          </a>
        </div>
      </div>
    </div>
  );
};

export default PremiumAccessModal;
